import type { CheckboxListField } from "@/types/template";

interface Props {
  field: CheckboxListField;
  value: string[];
  onChange: (value: unknown) => void;
}

export function CheckboxListInput({ field, onChange, value }: Readonly<Props>) {
  const toggle = (item: string) => {
    if (value.includes(item)) {
      onChange(value.filter((v) => v !== item));
    } else {
      onChange([...value, item]);
    }
  };

  return (
    <div className="checkbox-list-items">
      {field.items.map((item) => (
        <label key={item}>
          <input
            type="checkbox"
            checked={value.includes(item)}
            onChange={() => {
              toggle(item);
            }}
          />
          {item}
        </label>
      ))}
    </div>
  );
}
